import styles from "./styles.module.scss"
import MobileAppIcon from "../../../assets/mobileAppIcon.png"

export const DownloadMobileAppBanner = ({ onInstall }: { onInstall: () => void }) => {
  return (
    <div className={styles.installAppContainer}>
      <img src={MobileAppIcon} alt="Mobile App Icon" className={styles.appIcon} />
      <div className={styles.appText}>
        <p className={styles.mainText}>Cruisen</p>
        <p className={styles.subText}>Get the best experience!</p>
      </div>
      <button
        className={styles.installButton}
        onClick={() => {
          onInstall()
        }}
      >
        Install
      </button>
    </div>
  )
}
